import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Link from 'components/link'
import { helloBabyPostPath } from 'lib/urls'
import LazyBackgroundImage from 'components/lazy-background-image'
import css from './post-card.scss'

const getContainerClass = (cardSize) => {
  switch (cardSize) {
    case 'small':
      return css.small
    case 'medium':
      return css.medium
    default:
      return css.small
  }
}

const PostCard = ({
  post,
  navigateWithRouter,
  cardSize,
  numColumns,
  className,
  slug,
  topic,
  image,
  title,
  teaserText,
}) => {
  const navigationProp = {
    [!navigateWithRouter ? 'url' : 'to']: helloBabyPostPath(
      (post && post.slug) || slug
    ),
  }

  const containerClass = getContainerClass(cardSize)

  return (
    <div
      className={classNames(
        css.postCard,
        css['col-' + numColumns],
        containerClass,
        className
      )}
    >
      <Link className="text-body" {...navigationProp}>
        <div className={classNames(css.postCardContainer)}>
          <LazyBackgroundImage
            src={image}
            className={classNames(
              css.featuredImage,
              'hover-overlay hover-lighten'
            )}
          />
          <div className={classNames(css.postInfo, 'flex-vertical-center')}>
            <div>
              <div
                className={classNames(
                  css.postTitle,
                  'h6 text-bold',
                  topic ? 'mtn mbn' : 'mts'
                )}
              >
                {title}
              </div>
              {teaserText ? (
                <p className={classNames(css.textSerifGuides, 'mbn')}>
                  {teaserText}
                </p>
              ) : null}
              {topic && topic.slug == 'sponsored' ? (
                <div
                  className={classNames(
                    css.postTopic,
                    'tiny text-light text-bold mtn mbn text-uppercase'
                  )}
                >
                  {topic.name}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </Link>
    </div>
  )
}

PostCard.propTypes = {
  post: PropTypes.object,
  className: PropTypes.string,
  navigateWithRouter: PropTypes.bool,
  cardSize: PropTypes.string,
  numColumns: PropTypes.number,
  content: PropTypes.object,
}

PostCard.defaultProps = {
  navigateWithRouter: true,
}

export default PostCard
